import { Component } from '@angular/core';

@Component({
  template:  `
    <p>Manage your users here</p>
  `
})
export class ManageUsersComponent { }


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/admin/manage-users.component.ts